import { useState, useEffect } from "react";
import { Eye } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VisitCounter = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    axios.get(`${API}/analytics/count`)
      .then(r => setCount(r.data.total))
      .catch(() => {});
  }, []);

  if (count === null || count === 0) return null;

  return (
    <div className="flex items-center gap-1.5 text-blue-300/30 text-xs" data-testid="visit-counter">
      <Eye className="w-3 h-3" />
      <span>{count.toLocaleString('fr-CA')} visiteurs</span>
    </div>
  );
};

export default VisitCounter;
